import getAccessToken from "@/lib/openapi/get-access-token";
import selectAccessTokenData from "./select-access-token-data";

export const getAccessTokenData = () => {
  const accessToken = getAccessToken();
  if (accessToken) {
    return selectAccessTokenData(accessToken);
  }
  return undefined;
};
